/* eslint-disable react-hooks/exhaustive-deps */
import { PDFViewer } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import GlobalTable from "../../../components/global-table";
import { Box, Button, Dialog, Gap, InputField, SelectField, Typography } from "../../../ppui";
import { theme } from "../../../theme";
import { getMonthInStringNotOneIndexBased } from "../../../utils/common";
// import { logger } from "../../../utils/logger";
import {
  ContentLayout,
  ContentTable,
} from "../../style";
import SalaryReportPdf from "./salary-report";
import { SalaryHeaders } from "./salaryreport.data";
import useSalaryReportService from "./use-salary-report-service";
import { logger } from "../../../utils/logger";
import { useAuthContext } from "../../../context/authContext";
function SalaryReport() {
  const {
    salaryReportListData,
    allowances,
    salaryReportSummary,
    salaryReportInputs,
    handleChange,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    salaryReportPDFData,
    organizationInfo,
    fetchAllSalaryReportData,
    // loadingAllSalaryReport,
    dataFetched,
    departmentLists,
    setDeptId,
    totalEmployee
  } = useSalaryReportService()
  const { orgDetails} = useAuthContext();
  const [openUploadImportModal, setOpenUploadImportModal] = useState(false);
  const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);
  const handleOpenUploadImportModal = () => setOpenUploadImportModal(true);
  const currentRoute = location.pathname.split('/').pop();
  // const [pdfReady, setPdfReady] = useState(false);
  // logger.log(openUploadImportModal,"openUploadImportModal")
  // const handleExportClick = async () => {
  //   await fetchAllSalaryReportData();
  // };
  const handleExportClick = async () => {
    // setPdfReady(false); // Reset PDF state
    await fetchAllSalaryReportData(); // Fetch new data based on selected department
    // setPdfReady(true); // Allow PDF download to update
    // handleOpenUploadImportModal()
  };

  useEffect(() => {
    handleExportClick()
  }, [salaryReportInputs])
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // logger.log(salaryReportListData, "salaryReportListprity")
  // logger.log(totalEmployee, "totalEmployee0000")
  // const orgInitials = organizationInfo.org_name.split(' ').map(word => word[0]?.toUpperCase()).join('');
  logger.log(salaryReportPDFData,dataFetched,"salaryReportPDFData-000")
  logger.log(orgDetails,"orgDetails000999")
  return (
    <>
      <ContentLayout>

        <ContentTable>
          <GlobalTable
            headers={SalaryHeaders(currentPage, rowsPerPage)}
            rows={salaryReportListData}
            ActiveSort={false}
            searchBox={true}
            columnManagement={true}
            avatar={true}
            stickyHeader="true"
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                {dataFetched && totalEmployee} Employees {currentRoute === "salary-wages-report" ? "Salary / Wages" : currentRoute === "salary-report" ? "Salary" : "Wages"}  Report {dataFetched && "of "} {getMonthInStringNotOneIndexBased(salaryReportPDFData[0]?.month)} {salaryReportPDFData[0]?.year}

                {/* {dataFetched && salaryReportSummary?.total_employee} Employees ESI Report {dataFetched && `of ${getMonthInStringNotOneIndexBased(esiReportPDFData[0]?.month)} ${esiReportPDFData[0]?.year}`} */}
                </Typography>
                 
              </>
            }
            actionRight={
              <>
              <InputField
                label="Report Month"
                name="month"
                type="month"
                valueSinc
                placeholder="Type Here..."
                value={salaryReportInputs?.report_month}
                onChange={(e) => handleChange(e.target.value, "report_month")}
                onKeyDown={(e) => e.preventDefault()}
                max={new Date().toISOString().slice(0, 7)}
              />
              <Button
                color="primary" variant="contained"
                onClick={handleClickOpen}
                disabled = {salaryReportListData.length === 0}
              >
                Export
              </Button>  
              
            </>
            }
          />
        </ContentTable>
      </ContentLayout>
        <Dialog
          title={`${currentRoute === "salary-wages-report" ? "Salary / Wages" : currentRoute === "salary-report" ? "Salary" : "Wages"}  Report`}
          closeButton={true}
          fullWidth
          maxWidth="xs"
          open={open}
          onClose={handleClose}
          onSubmit={()=>{
            handleExportClick()
            handleOpenUploadImportModal()
          }
        }
          separator
          //   footer={
          //   <>
          //   <Button variant="text" onClick={() => alert("Custom Action")}>Custom Footer Action</Button>,
          // </>
          // }
        >
          <Typography variant="h6" mb="0">
             {dataFetched && "Month of "} {getMonthInStringNotOneIndexBased(salaryReportPDFData[0]?.month)} {salaryReportPDFData[0]?.year}
          </Typography>
          <Gap height={20}/>
           <SelectField
            label="Select Departments"
            fullWidth
            options={departmentLists}
            disabled = {salaryReportListData.length === 0}
            onChange={(e)=>{
              setDeptId(e)
            }}
          />

              {/* <Button
                color="primary"
                variant="contained"
                onClick={handleExportClick}
                loading={loadingAllSalaryReport}
                disabled={salaryReportListData.length === 0}
              >
                Export
              </Button>
              {pdfReady && (
                <PDFDownloadLink
                  document={
                    <SalaryReportPdf
                      allowances={allowances}
                      salaryReportSummary={salaryReportSummary}
                      salaryReportPDFData={salaryReportPDFData}
                      organizationInfo={organizationInfo}
                    />
                  }
                  fileName="salary-report.pdf"
                >
                  {({ loading }) =>
                    loading ? "Generating PDF..." : "Download PDF"
                  }
                </PDFDownloadLink>
              )} */}
        </Dialog>
        <Dialog
          title={`${currentRoute === "salary-wages-report" ? "Salary / Wages" : currentRoute === "salary-report" ? "Salary" : "Wages"}  Report ${dataFetched && "of "} ${getMonthInStringNotOneIndexBased(salaryReportPDFData[0]?.month)} ${salaryReportPDFData[0]?.year}`}
          closeButton={true}
          action={false}
          fullWidth
          maxWidth="xxl"
          bodyScroll={true}
          open={openUploadImportModal}
          onClose={handleCloseUploadImportModal}
          
        >
        <Box height="85vh" sx={{overflow:"hidden",borderRadius:theme.radius.list}}>
          <PDFViewer document={<SalaryReportPdf />} showToolbar={true} width="100%" height="100%" style={{border:"none"}}>
            <SalaryReportPdf
                      allowances={allowances}
                      salaryReportSummary={salaryReportSummary}
                      salaryReportPDFData={salaryReportPDFData}
                      organizationInfo={organizationInfo}
                      orgDetails={orgDetails}
                    />
          </PDFViewer>
          {/* {`${organizationInfo.org_name.replace(/\s+/g, '_')}-epf-report.pdf`} */}
        </Box>
      </Dialog>
    </>
  );
};

export default SalaryReport;


